const APIimg = "XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX";
export function getProductImg(path, width) {
  // return path ? `https://image.tmdb.org/t/p/${path}` : placeholder;
  return path ? path : "/placeholder.jpg";
}
